import React from 'react';

const SuccessModal = ({ isOpen, onClose, title = "Success!", message = "Operation completed successfully" }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const CheckIcon = () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="mx-auto mb-4"
    >
      <circle cx="30" cy="30" r="30" fill="#2BB927" />
      <path
        d="M18 30L26 38L42 22"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div
      className="fixed inset-0 z-50 flex backdrop-blur-sm shadow-2xl items-center justify-center bg-black bg-opacity-50"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 text-center shadow-2xl">
        <CheckIcon />
        <h2
          id="modal-title"
          className="text-2xl font-bold text-sky-950 mb-2"
        >
          {title}
        </h2>
        <p className="text-gray-600 mb-6">
          {message}
        </p>
        <button
          onClick={onClose}
          className="w-full px-6 py-3 bg-green-500 text-white font-semibold rounded-xl hover:bg-green-600 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
